import styled, { StyledProps } from 'styled-components/macro';

export type FileStyleProps = StyledProps<{
  failed: boolean;
}>;

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 3px;
`;

export const Name = styled.div`
  color: #424242;
  font-size: 12px;
`;

export const Info = styled.div`
  color: #999;
  font-size: 12px;
`;

export const Remove = styled.div`
  cursor: pointer;
`;

export const Retry = styled.div`
  font-size: 12px;
  color: #0ea3f5;
  cursor: pointer;
  width: 30px;
`;

export const Wrapper = styled.div<FileStyleProps>`
  display: flex;
  width: 385px;
  margin-left: -15px;
  padding: 0 15px;
  height: 33px;
  align-items: center;
  justify-content: space-between;
  border-radius: 3px;
  background-color: ${props => props.failed ? 'rgba(207, 72, 69, 0.1)' : '#fff'}
`;

export const Failed = styled.div`
  font-size: 12px;
  color: #cf4845;
`;
